import { useContext, useEffect } from "react";
import { Card, Dialog, Link } from "@mui/material";
import { Button } from "@mui/material";
import { loginContext, adminDrawerContext } from "../context/contexts";
import { getKeyByValue } from "../context/contextmanager";
import { getobj, dltobj, updateobj } from "../apicall/apicall";
import { useState } from "react";
import {
  boxStyle,
  StyledTableCell,
  StyledTableRow,
  searchStyle,
  crossHubAction,
  headerStyle,
} from "../style/style";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import "react-notifications/lib/notifications.css";
import { MenuItem, TextField } from "@mui/material";
import { DialogActions, DialogTitle } from "@mui/material";
import HubHistoryTrail from "./HubHistoryTrail";
import CloseIcon from "@mui/icons-material/Close";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { timeStamp } from "../apicall/commonFunction";

export default function Hublist() {
  const [hubs, sethubs] = useState();
  const [page, setpage] = useState(
    sessionStorage.getItem("hub_page")
      ? parseInt(sessionStorage.getItem("hub_page"))
      : 1
  );
  const [totalpage, setpaget] = useState();
  const [refresh, setrefresh] = useState(false);
  const [search, setsearch] = useState("");
  const [loaded, setloaded] = useState(true);
  const [comments, setcomments] = useState({ comments: "", id: "" });
  const [open, setopen] = useState(false);
  const [hubTrail, sethubTrail] = useState({ id: "", value: false });

  const adminDrawer = useContext(adminDrawerContext);

  const handlesearch = (e) => {
    setpage(1);
    setpaget(1);
    e.preventDefault();
    setrefresh(!refresh);
  };

  const context = useContext(loginContext);

  const handleClick = (id) => {
    const nm = getKeyByValue(context.page, true);
    context.sethub(id);
    context.setpage({
      ...context.page,
      [nm]: false,
      HubDevices: true,
    });
  };
  const handlePagechange = (event, value) => {
    setloaded(true);
    const url = `${process.env.REACT_APP_ZEWA_URL}hub/0/?page=${value}`;
    const d = getobj(url);
    d.then(function (res) {
      sethubs(res.results);
      setpage(value);
      setloaded(false);
    });
  };
  const handleaction = (id, val, hub_id) => {
    //console.log(id, val);

    if (val === "Detail") {
      context.sethubId(hub_id);
      sessionStorage.setItem("hub_page", page);
      handleClick(id);
    } else if (val === "action") {
      sethubTrail({
        id: id,
        value: true,
      });
    } else if (val === "Delete") {
      handleDelete(id);
    } else if (val === "Update Comment") {
      setcomments({
        ...comments,
        id: id,
        comments: "",
      });
      setopen(true);
    } else {
      const url = process.env.REACT_APP_ZEWA_URL + "hub/0/";
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = {
        id: id,
        customer_id: sessionStorage.getItem("customer_id"),
        active_status: status,
      };
      updateobj(url, data)
        .then((response) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          if (response.status === 200) {
            NotificationManager.success(response.Message, "Updated", 2000);
            setrefresh((prev) => !prev);
            setpage(1);
          } else {
            NotificationManager.error(response.Message, "Failed", 2000);
          }
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error(
            err?.Message || "Something went wrong",
            "Failed",
            2000
          );
        });
      // console.log(data);
    }
  };

  const updatecomment = (comments) => {
    console.log(comments);
    const url =
      process.env.REACT_APP_ZEWA_URL + "hub/comment/" + comments["id"] + "/";
    const res = updateobj(
      url,
      comments["comments"] === "{}" ? "" : comments["comments"]
    );
    res.then(function (res) {
      //console.log(res);
      setpage(1);
      setcomments("");
      setopen(false);
      setrefresh(!refresh);
    });
  };

  useEffect(() => {
    let url = "";
    if (search === "") {
      url = process.env.REACT_APP_ZEWA_URL + "hub/0/?page=1";
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "hub/0/?search=" +
        search +
        "&page=" +
        page;
    }
    const res = getobj(url);
    res.then(function (r) {
      if (r.count % 5 > 0) {
        setpaget(Math.floor(r.count / 5) + 1);
      } else {
        setpaget(Math.floor(r.count / 5));
      }
      sethubs(r.results);
      setloaded(false);
    });
  }, [refresh, search]);
  const handleDelete = (id) => {
    const url = process.env.REACT_APP_ZEWA_URL + "hub/0/";
    const res = dltobj(url, { id: id });
    res.then(function (res) {
      if (res["Message"] === "Hub deleted successfully") {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Hub Deleted.", "Deleted", 2000);
        setrefresh(!refresh);
      } else if (
        res["Messgae"] === "You do not have access to delete the hub"
      ) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "You do not have access to delete the hub",
          "Failed",
          2000
        );
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "Could not delete as it is associated with device",
          "Failed",
          2000
        );
      }
    });
  };
  const handleLink = (id) => {
    sessionStorage.setItem("hub_d", false);
    sessionStorage.setItem("value", 5);
    adminDrawer.setbuttonText("Organization");
    const nm = getKeyByValue(context.page, true);
    context.setid(id);
    context.setcustomer_id(id);
    context.setpage({
      ...context.page,
      [nm]: false,
      userDetail: true,
    });
  };

  return (
    <div>
      <Card sx={boxStyle}>
        <Card sx={headerStyle}>
          Hubs
          <form style={searchStyle} onSubmit={handlesearch}>
            <FormControl variant="standard" sx={searchStyle}>
              <InputLabel htmlFor="input-with-icon-adornment">
                Search ...
              </InputLabel>
              <Input
                id="input-with-icon-adornment"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchSharpIcon color="primary" />
                  </InputAdornment>
                }
                value={search}
                onChange={(e) => {
                  setsearch(e.target.value);
                  if (e.target.value === "") {
                    handlesearch(e);
                  }
                }}
              />
            </FormControl>
          </form>
        </Card>
      </Card>
      <Card sx={boxStyle}>
        {loaded ? (
          <img
            src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
            alt="loading..."
          />
        ) : hubs ? (
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <b>Hub Id</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Last Active</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Organisation Name</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Status</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Free Period</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Comments</b>
                  </StyledTableCell>

                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hubs &&
                  hubs.map((hub) => (
                    <StyledTableRow key={hub.id}>
                      <StyledTableCell>{hub.hub_id}</StyledTableCell>
                      <StyledTableCell>
                        {hub.last_active === "NA"
                          ? "No Data"
                          : timeStamp(hub.last_active)}
                      </StyledTableCell>
                      <StyledTableCell>
                        <Link
                          onClick={() => {
                            handleLink(hub.customer_id);
                          }}
                        >
                          {hub.org_name}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell>
                        {hub.active_status ? "Active" : "Inactive"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {hub.free_period_detail &&
                        hub.free_period_detail.free_time_period !== ""
                          ? hub.free_period_detail.free_time_period
                          : "0"}{" "}
                        months
                      </StyledTableCell>
                      <StyledTableCell>{hub.comments}</StyledTableCell>

                      <StyledTableCell>
                        <Button>
                          <TextField
                            select
                            name="device_name"
                            id="deviceName"
                            sx={{ width: "100px" }}
                            variant="outlined"
                            label="Action"
                            //value={actValue}
                            onChange={(e) => {
                              handleaction(hub.id, e.target.value, hub.hub_id);
                            }}
                          >
                            <MenuItem value="Detail">Devices</MenuItem>
                            <MenuItem
                              value={
                                hub.active_status ? "Deactivate" : "Activate"
                              }
                            >
                              {hub.active_status ? "Deactivate" : "Activate"}
                            </MenuItem>
                            <MenuItem value="Update Comment">
                              Update Comment
                            </MenuItem>
                            <MenuItem value="Delete">Delete</MenuItem>
                            <MenuItem value="action">Actions</MenuItem>
                          </TextField>
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
            <Pagination
              count={totalpage}
              page={page}
              variant="outlined"
              color="primary"
              onChange={handlePagechange}
            />
          </TableContainer>
        ) : (
          "No Hubs added yet."
        )}
        <NotificationContainer />

        <Dialog open={open} onClose={() => setopen(false)}>
          <DialogTitle>Add Comments</DialogTitle>

          <TextField
            label="Add Comments"
            name="comments"
            id="deviceName"
            sx={{ width: "400px", margin: "5px" }}
            variant="outlined"
            // value={test_device}
            onChange={(e) => {
              setcomments({
                ...comments,
                comments: e.target.value,
              });
            }}
          ></TextField>
          <DialogActions>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                setopen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                console.log(comments);
                updatecomment(comments);
              }}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Card>
      <Dialog
        open={hubTrail.value}
        onClose={() => {
          sethubTrail({
            id: "",
            value: false,
          });
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <CloseIcon
            sx={crossHubAction}
            onClick={() => {
              sethubTrail({
                id: "",
                value: false,
              });
            }}
          />
        </div>
        <HubHistoryTrail hub_id={hubTrail} />
      </Dialog>
    </div>
  );
}
